import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';
import { StorageUtil } from '../../shared/utils/storage.util';

@Injectable({
    providedIn: 'root'
})
export class NavigationUtilityService {

    private _isExpanded = new Subject<boolean>();
    isExpanded$ = this._isExpanded.asObservable();

    isExpanded = false;

    constructor() { }

    init(): void {
        this.isExpanded = StorageUtil.getItem('smarts-nav-menu-expanded') === 'true';
    }

    expandCollapseNavMenu(): void {
        this.setIsExpanded();
        StorageUtil.setItem('smarts-nav-menu-expanded', JSON.stringify(this.isExpanded));
    }

    setIsExpanded(): void {
        this.isExpanded = !this.isExpanded;
        this._isExpanded.next(true);
    }
}
